// Final-state commercial pricing for the public marketing site.
// The live Stripe setup is managed separately while the block-based billing
// implementation is completed.

export type Plan = {
  id: "month" | "year";
  price: string;
  label: string;
  priceSuffix: string;
};

const _fmt = (cents: number) =>
  `$${(cents / 100).toLocaleString("en-AU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const SeatsPlan = {
  baseSeats: 10,
  basePrice: _fmt(300_000),
  extraSeatBlockSize: 5,
  extraSeatBlockPrice: _fmt(100_000),
  priceSuffix: "/ year",
  currency: "AUD",
} as const;

export const selectedPlan: Plan = {
  id: "year",
  price: SeatsPlan.basePrice,
  label: `${SeatsPlan.baseSeats} seats`,
  priceSuffix: "/ year",
};
